<template>
  <div :class="$style['pt-page-menu-filter']">
      <el-menu mode="horizontal" :default-active="crrentValue" @select="select"  v-if="tabs">
          <el-menu-item v-for="(item,index) in tabs" :key="index" :index="isStringArr?item:(item[valueName]||String(index+1))">
            {{item[labelName]||item}}
            <span v-if="showCountOfRightTop&&item.count" :class="$style['count']">{{item.count}}</span>
          </el-menu-item>
      </el-menu>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-page-menu-filter'

export default {
  name: 'pt-page-menu-filter',
  props: {
    // 是否是字符串数组，如果是字符串数组，则返回数据和显示数据直接是item
    isStringArr: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    value: {
      type: [Number, String],
      default: ''
    },
    labelName: {
      // label[显示的]文字
      type: String,
      default: 'label'
    },
    valueName: {
      // value[label对应的值的key]
      type: String,
      default: 'value'
    },
    state: {
      // 链接的字段名
      type: String,
      default: 'state'
    },
    isRouteQuery: {
      type: Boolean,
      default: true
    },
    // 返回的字段
    resValue: {
      type: String,
      default: ''
    },
    showCountOfRightTop: Boolean
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      crrentValue: this.value || (this.tabs[0] && this.tabs[0][this.valueName]) || '1'
    }
  },
  watch: {
    tabs: {
      handler: function (val) {
        if (!this.value) {
          this.crrentValue = this.tabs[0] && this.tabs[0][this.valueName]
          this.resData(this.crrentValue)
        }
      },
      deep: true
    },
    value (val) {
      this.crrentValue = val
    }
  },
  methods: {
    select (key, keyPath) {
      if (this.isRouteQuery) {
        this.$router.push(window.location.pathname + '?' + this.state + '=' + key)
        this.$emit('fromRouter', false)
      }
      this.resData(key, true)
    },
    resData (key, isSelect) {
      if (this.resValue) {
        this.tabs.forEach(item => {
          if (item[this.valueName] === key) {
            this.$emit('select', item[this.resValue])
            this.$emit('input', item[this.resValue])
          }
        })
      } else {
        if (isSelect) {
          this.$emit('select', key)
        }
        this.$emit('input', key)
      }
    }
  },
  created () {
    if (this.isRouteQuery && !this.$route.query[this.state]) {
      this.$router.push(window.location.pathname + '?' + this.state + '=' + this.crrentValue)
    }
    if (this.$route.query[this.state]) {
      this.tabs.forEach(item => {
        if (item[this.valueName] === this.$route.query[this.state]) {
          this.crrentValue = this.$route.query[this.state]
          this.resData(this.crrentValue)
        }
      })
      this.$emit('fromRouter', true)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-page-menu-filter{
    margin-bottom: 20px;
    :global
    .el-menu--horizontal{
        display: inline-block;
        padding: 0 15px;
        .el-menu-item{
            font-size: 15px;
            margin-right: 30px;
            line-height:40px;
            height: 40px;
            &:focus{
                color:#909399;
            }
            &.is-active{
                color:#edbe81
            }
        }
    }
    .count{
      position:absolute;
      right: 5px;
      top: 3px;
      font-size: 12px;
      background-color: #edbe81;
      color:#fff;
      padding: 2px;
      height: 18px;
      padding: 0 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
    }
}
</style>
